import { Copy, Link2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { toast } from "sonner";
import { withTrace } from "@/hooks/useTraceSection";

interface UrlCopySectionProps {
  shareUrl: string;
  loading?: boolean;
  eventUuid?: string;
}

export function UrlCopySection({
  shareUrl,
  loading = false,
  eventUuid,
}: UrlCopySectionProps) {
  const { t } = useTranslation();

  const handleCopyUrl = async () => {
    if (!shareUrl) {
      console.error("shareUrl is empty, cannot copy");
      toast.error(t("events.share.copyError"));
      return;
    }

    await withTrace("shareModal", "copyUrl", async (span) => {
      span.setAttribute("event.uuid", eventUuid ?? "");
      try {
        await navigator.clipboard.writeText(shareUrl);
        toast.success(t("events.share.copied"));
      } catch (error) {
        const err = error as Error;
        span.recordException(err);
        console.error("Failed to copy link:", err, "shareUrl:", shareUrl);
        toast.error(t("events.share.copyError"));
      }
    }, {
      eventUuid: eventUuid ?? "",
    });
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-xs font-medium">
        <span>{t("events.share.eventLinkEmail")}</span>
        <Link2 className="h-4 w-4" />
        <span>{t("events.share.email")}</span>
      </div>
      <Button
        variant="outline"
        onClick={handleCopyUrl}
        disabled={!shareUrl || loading}
        className="w-full justify-center text-sm"
      >
        <Copy className="mr-2 h-4 w-4" />
        <span className="text-xs">{t("events.share.copyUrl")}</span>
      </Button>
      <p className="text-xs text-muted-foreground">
        {t("events.share.emailDescription")}
      </p>
    </div>
  );
}

